import React from 'react';
//CSS
import styles from './SelfAssessmentFormat.module.css';
import { IQuestionnaireSection } from '../../../../Types/Products/IQuestionnaireSection';
import { IGrade } from '../../../../Types/IGrade';
import GradeSelector from '../../../Utils/GradeSelector/GradeSelector';
import format from '../Formats.module.css';
//Components
//Data

export type DiagnosticSummaryResponse = {
    sections: IQuestionnaireSectionReport[];
    sources?: string[];
    introduction?: string;
}

export type ICriteriaItemReport = {
    id: string,
    title: string,
    summary: string,
    active: boolean,
    areasForImprovement: string[],
    grade: IGrade,
}

export type IQuestionnaireSectionReport = {
    id: string,
    title: string,
    description: string,
    criteria: ICriteriaItemReport[],
    grade: IGrade
}

const SelfAssessmentFormat = ({ sections, introduction } : DiagnosticSummaryResponse) => {
  return (
    <div className={styles.container}>

      <section className={styles.header}>
        <h1 className={styles.font}>Introduction</h1>
        <p className={styles.description}>{introduction}</p>
      </section>

      <section className={`${styles.sectionsList}`}>
        {
            sections?.map((section, sectionIndex) => (

                <div key={sectionIndex} className={`${styles.section} ${styles.questionSection}`}>

                    <div className={styles.section}>

                        <div className={styles.title}>
                            <h2 className={styles.font}>{section.title}</h2>
                            <GradeSelector grade={section.grade} readOnly={true}></GradeSelector>
                        </div>
                    
                        <p className={styles.description}>{section.description}</p>
                    </div>
                    
                    <div className={styles.section}>
                        {
                            section.criteria?.map((criterion, criterionIndex) => (

                                <div key={criterionIndex} className={`${styles.section} ${styles.criteriaSection}`}>

                                    <div className={styles.header}>
                                        <div className={styles.title}>
                                            <h3 className={styles.font}>{criterion.title}</h3>
                                            <GradeSelector grade={criterion.grade} readOnly={true}></GradeSelector>
                                        </div>
                                        <p className={styles.description}>{criterion.summary}</p>
                                    </div>

                                    <div className={styles.header}>
                                        <h4 className={styles.font}>Areas for Improvement</h4>
                                        <ul className={styles.list}>
                                            {criterion.areasForImprovement?.map((areaForImprovement, areaIndex) => (
                                                <li key={areaIndex}>{areaForImprovement}</li>
                                            ))}
                                        </ul>
                                    </div>
                                
                                </div>
                            ))
                        }
                    </div>
                </div>
            ))
        }
      </section>
    </div>
  );
};

export default SelfAssessmentFormat;